
import { HttpClient } from '@angular/common/http';
import { ApiService } from './api.service';
import { EventEmitter, Injectable } from '@angular/core';
import { WindowRefService } from '@services/window.service';

@Injectable({
  providedIn: 'root'
})
export class SignalRService extends ApiService {

  messageReceived = new EventEmitter<any>();
  connectionEstablished = new EventEmitter<Boolean>();
  private hubConnection: any;

  constructor(private http: HttpClient,
    private window: WindowRefService) {
    super();

    var jQuery = this.window.nativeWindow.jQuery;

    if (typeof jQuery === "undefined") {
      throw new Error("jQuery is not defined on the global object.");
    }
    if (typeof jQuery.hubConnection === "undefined") {
      throw new Error("SignalR is not defined on the jQuery object.");
    }

    this.hubConnection = jQuery.connection.notificationHub;
  }

  public startConnection(message: string): void {

    this.hubConnection.on(message, (data: any) => {
      this.messageReceived.emit(data);
    });

    this.window.nativeWindow.jQuery.connection.hub.disconnected(() => {
        console.log('Hub connection lost, reconnecting');
        this.window.nativeWindow.jQuery.connection.hub.start();
    });

    this.window.nativeWindow.jQuery.connection.hub.start()
      .done(() => {
        console.log('Hub connection started');
        this.connectionEstablished.emit(true);
      })
      .fail(() => {
        console.log('Error while establishing connection, retrying...');
        this.window.nativeWindow.jQuery.connection.hub.start();
      });

  }
}
